var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomHeadline',{attrs:{"custom-title":"A kezdeményezésről"}}),_c('AboutInitiative'),_c('CustomHeadline',{attrs:{"custom-title":"Csapatunk"}}),_c('TeamContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }